export default "__VITE_ASSET__BlpWlSQs__"